import { render, staticRenderFns } from "./signup-form.vue?vue&type=template&id=b93e5f16&scoped=true"
import script from "./signup-form.vue?vue&type=script&lang=js"
export * from "./signup-form.vue?vue&type=script&lang=js"
import style0 from "./signup-form.vue?vue&type=style&index=0&id=b93e5f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93e5f16",
  null
  
)

export default component.exports